import React, { useMemo, memo, FC } from 'react';

import { List, Item } from './styled';

import dayjs from 'dayjs';

import { generateTime, separateTime, checkDisabled, checkSelected } from './helpers';

import { TimePickerProps } from '../types';

import { TIME_FORMAT } from './const';

export interface TimeListProps
  extends Pick<
    TimePickerProps,
    | 'minuteStep'
    | 'disabledHours'
    | 'disabledMinutes'
    | 'hourStep'
    | 'value'
    | 'hideDisabledOptions'
  > {
  onChange: (time?: TimePickerProps['value']) => void;
}

const TimeList: FC<TimeListProps> = ({
  minuteStep,
  hourStep,
  disabledHours,
  disabledMinutes,
  value,
  hideDisabledOptions,
  onChange,
}) => {
  const timeList = useMemo(() => generateTime({ minuteStep, hourStep }), [minuteStep, hourStep]);

  return (
    <div>
      <List>
        {timeList.map(time => {
          const [hour, minute] = separateTime(time);
          const isHideHour = checkDisabled(hour, disabledHours?.());
          const isHideMinute = checkDisabled(minute, disabledMinutes?.(hour));
          const isSelected = checkSelected(time, value);

          return (
            <Item
              key={time}
              hide={isHideHour || isHideMinute}
              disabled={hideDisabledOptions}
              selected={isSelected}
              onClick={() => {
                onChange(dayjs(time, TIME_FORMAT));
              }}
            >
              {time}
            </Item>
          );
        })}
      </List>
    </div>
  );
};

export default memo(TimeList);
